<template>
  <div>
    <validation-observer ref="observer">
      <base-box title="保險需求與風險屬性">
        <span v-if="isTypeR" style="color:red">下面問項若標註★，請確認是否與要保書填寫內容一致</span>
        <div class="form-box mt-default">
          <sub-title-qa :style="typeStyle"><span>★</span>本次投保之目的及需求(可複選)</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12" :class="typeRCss">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <v-layout row
                          wrap
                          class="form">
                  <validation-provider vid="vpurSelect"
                                        name="本次投保之目的及需求"
                                        rules="required">
                    <input :value="purSelect.join('')"
                           style="height:0;width:0"
                           :disabled="isPreview"
                           id="vpurSelect" />
                  </validation-provider>
                  <v-flex v-for="(item,index) in purList"
                          :key="index">
                    <v-checkbox v-model="purSelect"
                                v-checker
                                :hide-details="item.codeDesc=='OTHER' ? true : false"
                                :label="item.codeName"
                                :value="item.codeValue"
                                :disabled="isPreview"
                                class="shrink mr-2 d-in-block">
                    </v-checkbox>
                    <b-text-field v-if="item.codeDesc=='OTHER'"
                                  :disabled="!purSelect.includes(item.codeValue)"
                                  v-model="written.purOther"
                                  v-checker
                                  @click.stop
                                  outline
                                  hide-details
                                  placeholder="輸入文字"
                                  style="width:200px"
                                  class="d-in-block"
                                  :vname="item.codeName"
                                  vid="vpurSelectOther"
                                  :rules="(purSelect.includes(item.codeValue))?'required':''"
                                  maxlength="20"
                                  mode="lazy">
                    </b-text-field>
                  </v-flex>
                  <v-flex xs12>
                  </v-flex>
                </v-layout>
              </validation-observer>
                 <base-note no-num
                 style="margin-top:10px">若您投保簽名後會更新為要保文件之保費及保額，以及預勾同意的投保目的與保費來源若有差異會採聯集方式更新呈現
                 </base-note>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa >欲投保之保險種類</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
            <validation-observer v-slot="{errors}">
              <error-messages :value="errorsHandler(errors)"></error-messages>
              <validation-provider rules="required"
                                   vid="insType"
                                   name="欲投保之保險種類"
                                   mode="lazy">
              <v-radio-group v-model="written.insTypeCode"
                              class="pd-left block"
                              row>
                <v-layout row
                          wrap
                          class="form align-center">
                  <v-flex v-for="(item, index) in insTypeList"
                          :key="index"
                          class="shrink mr-2 d-in-block">
                    <v-radio :value="item.codeValue" :disabled="isPreview" @change="checkInsTypeCode($event)">
                      <template v-slot:label>
                        <div>{{ item.codeName}}</div>
                        <b-text-field v-if="item.codeDesc=='OTHER'"
                                      :disabled="!written.insTypeCode.includes(item.codeValue)"
                                      outline
                                      v-checker
                                      @click.stop
                                      maxlength="20"
                                      hide-details
                                      vid="vinsTypeOther"
                                      placeholder="輸入文字"
                                      :vname="item.codeName"
                                      :rules="(written.insTypeCode.includes(item.codeValue))?'required':''"
                                      v-model="written.insTypeOther"
                                      class="d-in-block ml-2 mr-2 no-pd "
                                      style="width:200px"></b-text-field>
                      </template>
                    </v-radio>
                  </v-flex>
                </v-layout>
               </v-radio-group>
              </validation-provider>
            </validation-observer>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>是否有指定之保險公司</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
            <validation-observer v-slot="{errors}">
              <error-messages :value="errorsHandler(errors)"></error-messages>
              <validation-provider rules="required"
                                   vid="insType"
                                   name="是否有指定之保險公司"
                                   mode="lazy">
              <v-layout row
                        wrap
                        class="form">
                <v-radio-group row
                               v-model="compCode">
                  <v-radio v-for="(item,index) in compList"
                           :key="index"
                           :label="item.codeName"
                           :value="item.codeValue"
                           :disabled="true"></v-radio>
                </v-radio-group>
              </v-layout>
              </validation-provider>
            </validation-observer>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>欲投保之保險金額</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
            <b-text-field v-model="written.faceAmt"
                              v-checker
                              :disabled="isPreview"
                              outline
                              maxlength="19"
                              style="width:200px"
                              vid="vfaceAmt"
                              vname="欲投保之保險金額"
                              rules="required|isDecimalPoint:14,4"></b-text-field>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa :style="typeStyle"><span>★</span>是否已有投保其他商業保險之有效保險契約</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12" :class="typeRCss">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider rules="required"
                                      vid="vinsOtherYn"
                                      name="是否已有投保其他商業保險之有效保險契約"
                                      mode="lazy">
                  <v-radio-group row
                                  v-model="written.insOtherYn"
                                  v-checker
                                  id="vinsOtherYn">
                    <v-radio v-for="(item,index) in ynList"
                              :key="index"
                              :disabled="isPreview"
                              :label="item.codeName"
                              :value="item.codeValue"></v-radio>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>要保人已確實瞭解其所繳交保險費係用於購買保險商品、購買外幣收付之保險商品匯率風險承受能力、投資型保險商品風險之承受能力及投資損益由保戶自行承擔，確實依要保人財力狀況提供適合的保險商品
          </sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider :rules="!acceptYnDisable ? 'required' : ''"
                                      vid="vinsAcceptYn"
                                      name="要保人已確實瞭解其所繳交保險費係用於購買保險商品、購買外幣收付之保險商品匯率風險承受能力、投資型保險商品風險之承受能力及投資損益由保戶自行承擔，確實依要保人財力狀況提供適合的保險商品"
                                      mode="lazy">
                  <v-flex xs12>
                    【僅投保外幣收付或投資型商品填寫】</v-flex>
                  <v-radio-group row
                                  v-model="written.insAcceptYn"
                                  v-checker
                                  id="vinsAcceptYn">
                    <v-radio v-for="(item,index) in ynList"
                              :key="index"
                              :label="item.codeName"
                              :value="item.codeValue"
                              :disabled="true"></v-radio>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>
            {{insHighAgeLimit + '歲(含)以上客戶是否具有辨識不利其投保權益情形之能力'}}
          </sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider :rules="!oldAgeDisable ? oldAgeYnRule : ''"
                                      vid="voldAgeYn"
                                      :name="insHighAgeLimit + '歲(含)以上客戶是否具有辨識不利其投保權益情形之能力'"
                                      mode="lazy">
                  <v-radio-group row
                                  v-model="written.oldAgeYn"
                                  v-checker
                                  id="voldAgeYn">
                    <v-radio v-for="(item,index) in oldAgeYnList"
                              :key="index"
                              :label="item.codeName"
                              :value="item.codeValue"
                              :disabled="isPreview || oldAgeDisable"></v-radio>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>
      </base-box>

      <base-box title="保險費支出">
        <div class="form-box mt-default">
          <sub-title-qa :style="typeStyle"><span v-if="isTypeR">★</span>預估繳交之保險費金額</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12" :class="typeRCss">
              <v-flex xs12>
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
               <validation-provider rules="required"
                                      vid="mode"
                                      name="預估繳交之保險費金額"
                                      mode="lazy">
                <v-radio-group row
                                v-model="written.mode">
                  <v-radio v-for="(item,index) in modeList"
                            :key="index"
                            :label="item.codeName"
                            :value="item.codeValue"
                            :disabled="isPreview"></v-radio>
                </v-radio-group>
                </validation-provider>
              </validation-observer>
              </v-flex>
             <v-flex xs2>
              <sub-title-qa :style="typeStyle">幣別： </sub-title-qa>
                  <b-auto-or-select v-model="written.curCode"
                                :items="premList"
                                item-text="codeName"
                                item-value="codeValue"
                                label="請選擇"
                                rules="required"
                                vname="幣別"
                                vid="curCode"
                                @change="checkCurCode($event)"
                                mode="lazy"></b-auto-or-select>
              <sub-title-qa :style="typeStyle">保費：</sub-title-qa>
              <b-text-field v-model="written.modePrem"
                            :disabled="isPreview"
                            outline
                            maxlength="20"
                            suffix="元"
                            vname="保費"
                            vid="modePrem"
                            rules="required|isDecimalPoint:14,4"
                            style="width:200px"
                            class="d-in-block"></b-text-field>
             </v-flex>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>1.繳交保險費之人預估退休剩餘年期</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider rules="required"
                name="繳交保險費之人預估退休剩餘年期"
                                     vid="vretireYear"
                                     mode="lazy">
                  <v-radio-group row
                                 v-model="written.retireYear"
                                 v-checker
                                 id="vretireYear">
                    <v-radio v-for="(item,index) in retireList"
                             :key="index"
                             :disabled="isPreview"
                             :label="item.codeName"
                             :value="item.codeValue"></v-radio>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>2.繳交保險費之來源(可複選)</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <v-layout row
                          wrap
                          class="form">
                  <validation-provider vid="vfeeSourceSelect"
                                        name="繳交保險費之來源"
                                        rules="required">
                    <input :value="feeSourceSelect.join('')"
                           style="height:0;width:0"
                           :disabled="isPreview"
                           id="vfeeSourceSelect" />
                  </validation-provider>
                  <v-flex v-for="(item,index) in feeSourceList"
                          :key="index">
                    <v-checkbox v-model="feeSourceSelect"
                                v-checker
                                :hide-details="item.codeDesc=='OTHER' ? true : false"
                                :label="item.codeName"
                                :value="item.codeValue"
                                :disabled="isPreview"
                                @change="checkFreeSource()"
                                class="shrink mr-2 d-in-block">
                    </v-checkbox>
                    <b-text-field v-if="item.codeDesc=='OTHER'"
                                  :disabled="!feeSourceSelect.includes(item.codeValue)"
                                  v-model="written.feeSourceOther"
                                  v-checker
                                  @click.stop
                                  outline
                                  hide-details
                                  placeholder="輸入文字"
                                  style="width:200px"
                                  class="d-in-block"
                                  :vname="item.codeName"
                                  vid="vfeeSourceSelectOther"
                                  :rules="(feeSourceSelect.includes(item.codeValue))?'required':''"
                                  maxlength="20"
                                  mode="lazy">
                    </b-text-field>
                  </v-flex>
                  <v-flex xs12>
                  </v-flex>
                </v-layout>
              </validation-observer>
                 <base-note no-num
                 style="margin-top:10px">若您投保簽名後會更新為要保文件之保費及保額，以及預勾同意的投保目的與保費來源若有差異會採聯集方式更新呈現
                 </base-note>
            </div>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default" v-if="written.plResult==='是'">
          <sub-title-qa>
                <font color="red" ><b>要保人三個月內是否保單解約和保單借款</b> </font>
          </sub-title-qa>
          <sub-content-qa>
             <span style="font-weight: bold; color: red; font-size: 16px;">{{written.plResult}}</span>
          </sub-content-qa>
        </div>
        <div class="form-box mt-default" v-if="written.plResult!=='是'">
          <sub-title-qa>
                要保人三個月內是否保單解約和保單借款
          </sub-title-qa>
          <sub-content-qa>
             {{written.plResult}}
          </sub-content-qa>
        </div>
        <div class="form-box mt-default">
          <sub-title-qa>方便客服電訪時段
          </sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <v-flex xs12>
                <b-text-field v-model="written.elecCallTime"
                              v-checker
                              :disabled="isPreview || elecCallDisable"
                              outline
                              maxlength="20"
                              style="width:200px"
                              vid="velecCallTime"
                              vname="方便客服電訪時段"
                              :rules="(!elecCallDisable) ? 'required' : ''"></b-text-field>
              </v-flex>
              <v-flex xs12>
                因本件保費來源或客戶三個月內有保單解約或保單借款，依規定需由證券客服電訪，倘客戶有偏好可電訪時段請填入(以8-17點為限)。
              </v-flex>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>*僅保費來源為貸款、保單解約金、定存解約或透過本公司保單借款填寫
          </sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider :rules="!insFinlevDisable ? insFinlevYnRule: ''"
                                     vid="vinsFinlevYn"
                                     name="保費來源"
                                     mode="lazy">
                  業務人員已向要保人說明保險費來源若為辦理貸款、保單解約
                  金、定存解約或透過本公司保單借款，將因財務槓桿操作方式所
                  面臨之相關風險及最大可能損失金額。
                  <v-radio-group row
                                 v-model="written.insFinlevYn"
                                 v-checker
                                 id="vinsFinlevYn">
                    <v-radio v-for="(item,index) in ynList"
                             :key="index"
                             :label="item.codeName"
                             :value="item.codeValue"
                             :disabled="isPreview || insFinlevDisable"></v-radio>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>
      </base-box>

      <base-box title="業務員建議事項">
        <div class="form-box mt-default">
          <sub-title-qa>保險公司名稱及概況</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <v-flex>
                <v-text-field v-model="written.compName"
                              disabled
                              outline
                              maxlength="20"
                              style="width:200px"></v-text-field></v-flex>
              <v-flex>人壽保險股份有限公司(詳官方網站)</v-flex>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>保險商品/險種名稱</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider vid="vproNameChk"
                                     name="保險商品/險種名稱"
                                     rules="required"
                                     mode="lazy">
                  <v-radio-group v-model="written.proNameChk"
                                 class="pd-left block"
                                 row
                                 v-checker
                                 id="vproNameChk">
                    <v-layout row
                              wrap
                              class="form align-center">
                      <v-flex v-for="(item, index) in selChkList"
                              :key="index"
                              class="shrink mr-2 d-in-block">
                        <v-radio :value="item.codeValue"
                                 :disabled="isPreview">
                          <template v-slot:label>
                            <div>{{ item.codeName }}</div>
                            <b-text-field v-if="item.codeDesc=='OTHER'"
                                          :disabled="isPreview || written.proNameChk!==item.codeValue"
                                          placeholder="輸入文字"
                                          outline
                                          maxlength="30"
                                          hide-details
                                          v-model="written.proNameOther"
                                          class="d-in-block ml-2 mr-2 no-pd "
                                          style="width:200px"
                                          v-checker
                                          :vname="item.codeName"
                                          vid="vproNameOther"
                                          :rules="written.proNameChk === item.codeValue ?'required':''"></b-text-field>
                          </template>
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>保險金額</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider vid="vfaceAmtChk"
                                     name="保險金額"
                                     rules="required"
                                     mode="lazy">
                  <v-radio-group v-model="written.faceAmtChk"
                                 class="pd-left block"
                                 row
                                 v-checker
                                 id="vfaceAmtChk">
                    <v-layout row
                              wrap
                              class="form align-center">

                      <v-flex v-for="(item, index) in selChkList"
                              :key="index"
                              class="shrink mr-2 d-in-block">
                        <v-radio :value="item.codeValue"
                                 :disabled="isPreview">
                          <template v-slot:label>
                            <div>{{ item.codeName }}</div>
                            <b-text-field v-if="item.codeDesc=='OTHER'"
                                          :disabled="isPreview || written.faceAmtChk!==item.codeValue"
                                          placeholder="輸入文字"
                                          outline
                                          maxlength="30"
                                          hide-details
                                          v-model="written.faceAmtOther"
                                          class="d-in-block ml-2 mr-2 no-pd "
                                          style="width:200px"
                                          v-checker
                                          :vname="item.codeName"
                                          vid="vfaceAmtOther"
                                          :rules="written.faceAmtChk === item.codeValue ?'required':''"></b-text-field>
                          </template>
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>保障範圍</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider vid="vcoverageChk"
                                     name="保障範圍"
                                     rules="required"
                                     mode="lazy">
                  <v-radio-group v-model="written.coverageChk"
                                 class="pd-left block"
                                 row
                                 v-checker
                                 id="vcoverageChk">
                    <v-layout row
                              wrap
                              class="form align-center">

                      <v-flex v-for="(item, index) in selChkList"
                              :key="index"
                              class="shrink mr-2 d-in-block">
                        <v-radio :value="item.codeValue"
                                 :disabled="isPreview">
                          <template v-slot:label>
                            <div>{{ item.codeName }}</div>
                            <b-text-field v-if="item.codeDesc=='OTHER'"
                                          :disabled="isPreview || written.coverageChk!==item.codeValue"
                                          placeholder="輸入文字"
                                          outline
                                          maxlength="30"
                                          hide-details
                                          v-model="written.coverageOther"
                                          class="d-in-block ml-2 mr-2 no-pd "
                                          style="width:200px"
                                          v-checker
                                          :vname="item.codeName"
                                          vid="vcoverageOther"
                                          :rules="written.coverageChk === item.codeValue ?'required':''"></b-text-field>
                          </template>
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>保險費及繳費年期</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider vid="vmodePremChk"
                                     name="保險費及繳費年期"
                                     rules="required"
                                     mode="lazy">
                  <v-radio-group v-model="written.modePremChk"
                                 class="pd-left block"
                                 row
                                 v-checker
                                 id="vmodePremChk">
                    <v-layout row
                              wrap
                              class="form align-center">

                      <v-flex v-for="(item, index) in selChkList"
                              :key="index"
                              class="shrink mr-2 d-in-block">
                        <v-radio :value="item.codeValue"
                                 :disabled="isPreview">
                          <template v-slot:label>
                            <div>{{ item.codeName }}</div>
                            <b-text-field v-if="item.codeDesc=='OTHER'"
                                          :disabled="isPreview || written.modePremChk!==item.codeValue"
                                          placeholder="輸入文字"
                                          outline
                                          maxlength="30"
                                          hide-details
                                          v-model="written.modePremOther"
                                          class="d-in-block ml-2 mr-2 no-pd "
                                          style="width:200px"
                                          v-checker
                                          :vname="item.codeName"
                                          vid="vmodePremOther"
                                          :rules="written.modePremChk === item.codeValue ?'required':''"></b-text-field>
                          </template>
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>建議投保保險公司理由</sub-title-qa>
          <sub-content-qa>
            <div class="flex align-baseline xs12">
              <validation-observer v-slot="{errors}">
                <error-messages :value="errorsHandler(errors)"></error-messages>
                <validation-provider vid="vinsReasonCode"
                                     name="保險費及繳費年期"
                                     rules="required"
                                     mode="lazy">
                  <v-radio-group v-model="written.insReasonCode"
                                 class="pd-left block"
                                 row
                                 v-checker
                                 id="vinsReasonCode">
                    <v-layout row
                              wrap
                              class="form align-center">

                      <v-flex v-for="(item, index) in insReasonList"
                              :key="index"
                              class="shrink mr-2 d-in-block">
                        <v-radio :value="item.codeValue"
                                 :disabled="isPreview">
                          <template v-slot:label>
                            <div>{{ item.codeName }}</div>
                            <b-text-field v-if="item.codeDesc=='OTHER'"
                                          :disabled="isPreview || written.insReasonCode!==item.codeValue"
                                          placeholder="輸入文字"
                                          outline
                                          maxlength="30"
                                          hide-details
                                          v-model="written.insReasonOther"
                                          class="d-in-block ml-2 mr-2 no-pd "
                                          style="width:200px"
                                          v-checker
                                          :vname="item.codeName"
                                          vid="vinsReasonOther"
                                          :rules="written.insReasonCode === item.codeValue ?'required':''"></b-text-field>
                          </template>
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </validation-provider>
              </validation-observer>
            </div>
          </sub-content-qa>
        </div>

        <div class="form-box mt-default">
          <sub-title-qa>報酬收取說明(凱基保經)</sub-title-qa>
          <sub-content-qa>
            <span style="color: red;">◎本公司依規定無另行向要保人收取任何型式報酬。</span>
          </sub-content-qa>
        </div>
      </base-box>
    </validation-observer>

    <base-dialog-full title="檢視要保書"
                      :show="showPdf"
                      :tempSaveBtn="false"
                      @close="pdfViewrClose">
      <v-layout ref="getHightA01">
        <pdf-viewer-with-image :cfgRatio="pdfViewerRatio"
                    :src="pdfUrlPath"
                    :stretch="false"
                    :usedMaskLoading="true"></pdf-viewer-with-image>
      </v-layout>
    </base-dialog-full>
    <base-btn>
      <btn-lg-default class="float-left" :disabled="isPreview" @click="resetHandler">全部清除</btn-lg-default>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary @click="nextStepHandler" v-if="'M' === polInsureType ">下一步</btn-lg-primary>
      <btn-lg-primary @click="nextStepHandler" v-if="'R' === polInsureType && !isPreview">轉跳保險公司</btn-lg-primary>

    </base-btn>
    <btn-lg-default style="position: fixed;top: 300px;right: 30px;min-width: 126px;max-width: 126px;" @click="preStepHandler" >上一步</btn-lg-default>
    <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px;" @click="nextStepHandler" v-if="'M' === polInsureType ">下一步</btn-lg-primary>
    <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px;" @click="nextStepHandler" v-if="'R' === polInsureType && !isPreview">轉跳保險公司</btn-lg-primary>
  </div>
</template>
<script>
import ProposalStepsBase from './ProposalStepsBase';
//fix by Issue #53784
import pdfViewerWithImage from '@/components/PDFViewer/PDFViewerWithImage.vue';
import { policyChangedChecker } from '@/mixin';
import store from '@/store';
import { withDebounce } from '@/utils';
import isEmpty from "lodash/isEmpty";
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('ins')

export default {
  extends: ProposalStepsBase,
  components: { pdfViewerWithImage },//fix by Issue #53784
  mixins: [policyChangedChecker],
  data() {
    return {
      transCode: null,
      compCode: '',
      status: null,
      reportSourceMap: null,
      insPoliciesDataList:[],
      insureAgeO:0,
      insureAgeI:0,
      cusCode:'',
      purSelect:[],
      showPdf:false,
      pdfBase64: null,
      pdfUrlPath: '',
      compYn:"Y",
      compOtherText:"",
      oldAgeDisable:false,
      acceptYnDisable:false,
      feeSourceSelect:[],
      callSourceIncludesFeeSource: false,
      callSourceCodeArray: [],
      insHighAgeLimit: 0,
      selChkList:[],
      selChkOther:{},
      insReasonList:[],
      insReasonOther:{},
      written: {
        transCode:'',
        purCode:'',
        purOther:'',
        insTypeCode:'',
        insTypeOther:'',
        faceAmt:'',
        insOtherYn:'',
        insAcceptYn:'',
        oldAgeYn:'',
        mode:'',
        curCode:'',
        modePrem:'',
        retireYear:'',
        feeSourceCode:'',
        feeSourceOther:'',
        elecCallTime:'',
        insFinlevYn:'',
        proNameChk:'',
        proNameOther:'',
        faceAmtChk:'',
        faceAmtOther:'',
        coverageChk:'',
        coverageOther:'',
        modePremChk:'',
        modePremOther:'',
        insReasonCode:'',
        insReasonOther:'',
        status:'',
        plResult: '',
        compCode: '',
        compName: ''
      },
      cusInfoTypeO: {}, //遠距增加，跳轉APP
      policiesInfo: {}, //遠距增加，跳轉APP
      isTypeR: false, //add by Issue #55276，是否為『案件類型』=R
      disableAll : false //add by Issue #55276，禁止編輯控制項
    }
  },
  computed: {
    insAppTime () {  //遠距增加，跳轉APP
      // APP提醒時間(ADM_PARMD-S01)
      let { parameterValue: limit, variableDesc: desc } = this.insParameters['APP_REMIND_TIME']
      limit = parseInt(limit)
      return {limit, desc}
    },
    purList () { // 本次投保之目的及需求
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'PUR_CODE'
      })
    },
    insTypeList () { // 欲投保之保險種類
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'INS_TYPE_CODE'
      })
    },
    ynList () { // 是否
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'SEL_YN'
      })
    },
    compList () { // 保險公司
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'COMP_CODE'
      })
    },
    oldAgeYnList() { // 65歲(含)以上客戶是否具有辨識不利其投保權益情形之能力
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'OLD_AGE_YN'
      })
    },
    modeList () { // 繳別
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'MODE'
      })
    },
    retireList () { // 退休剩餘年期
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'RETIRE_YEAR'
      })
    },
    feeSourceList () { // 繳交保險費之來源
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'FEE_SOURCE'
      })
    },
    elecCallDisable() { // 方便客服電訪時段
      if (this.written.plResult === "是" || this.callSourceIncludesFeeSource) {
        return false
      } else {
        return true
      }
    },
    insFinlevDisable() { // 僅保費來源為貸款、保單解約金、定存解約或透過本公司保單借款填寫
      if (this.written.plResult === "是" || this.callSourceIncludesFeeSource) {
        return false
      } else {
        return true
      }
    },
    pdfViewerRatio () {
        return '1.45'
    },
    insFinlevYnRule() {
      if (this.written.insFinlevYn === null || this.written.insFinlevYn === '' || this.written.insFinlevYn === 'N') {
        return 'showMsg:您尚未向客戶說明可能風險及最大損失或尚未填寫'
      } else {
        return ''
      }
    },
    oldAgeYnRule() {//fix: SCR #88098 ，加上 選擇"否"，額外出現訊息提示
      if (this.written.oldAgeYn === null || this.written.oldAgeYn === '' || this.written.oldAgeYn === 'N') {
        return 'showMsg:高齡客戶不具辨識能力不得投保或尚未填寫'
      } else {
        return ''
      }
    },
    typeStyle() {
     return 'color:blue'
    },
    typeRStyle() {
      if(this.isTypeR){
        return 'color:blue'
      }else{
        return ''
      }
    },
    typeRCss() {
       return 'typeR'
    },
    premList () {
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'CUR_CODE'
      })
    }
  },
  watch: {
    changedFlag (v) {
      if (v) {
        this.$setTabDone(this.tabStep, false)
      }
    },
    // 取消勾選其他清空input text
    purSelect () {
      const other = this.purList.filter(code => code.codeDesc === "OTHER");
      if (!this.purSelect.includes(other[0].codeValue)) {
        this.written.purOther = ''
      }
    },
    feeSourceSelect() {
      const other = this.feeSourceList.filter(code => code.codeDesc === "OTHER");
      if (!this.feeSourceSelect.includes(other[0].codeValue)) {
        this.written.feeSourceOther = ''
      }
    },
    'written.insTypeCode': {
      handler (v) {
        const other = this.insTypeList.filter(code => code.codeDesc === "OTHER")
       if (!v.includes(other[0].codeValue)) {
           this.written.insTypeOther = ''
        }
      },
      immediate: true
    },
    // 保險商品/險種名稱
    'written.proNameChk': {
      handler (v) {
        if (v !== this.selChkOther.codeValue) {
          this.written.proNameOther = ''
        }
      },
      immediate: true
    },
    // 保險金額
    'written.faceAmtChk': {
      handler (v) {
        if (v !== this.selChkOther.codeValue) {
          this.written.faceAmtOther = ''
        }
      },
      immediate: true
    },
    // 保障範圍
    'written.coverageChk': {
      handler (v) {
        if (v !== this.selChkOther.codeValue) {
          this.written.coverageOther = ''
        }
      },
      immediate: true
    },
    // 保險費及繳費年期
    'written.modePremChk': {
      handler (v) {
        if (v !== this.selChkOther.codeValue) {
          this.written.modePremOther = ''
        }
      },
      immediate: true
    },
    // 建議投保保險公司理由
    'written.insReasonCode': {
      handler (v) {
        if (v !== this.insReasonOther.codeValue) {
          this.written.insReasonOther = ''
        }
      },
      immediate: true
    }
  },
  mounted () {
    if (this.status === "S" && !this.isPreview) {
      this.$setTabDone(this.tabStep, true)
    }

    this.selChkList  = this.$store.getters['common/admCodeDetail']({codeType: 'SEL_CHK'})
    this.selChkOther = this.selChkList.filter(code => code.codeDesc === "OTHER")[0];
    this.insReasonList= this.$store.getters['common/admCodeDetail']({codeType: 'INS_REASON_CODE'})
    this.insReasonOther = this.insReasonList.filter(code => code.codeDesc === "OTHER")[0];

    // ADM_PARMD-S01
    // 高齡年齡限制
    let { parameterValue: limit } = this.insParameters['HIGH_AGE_LIMIT']
    this.insHighAgeLimit = parseInt(limit)

    // SRV_1
    this.oldAgeDisable = !(this.insureAgeO >= this.insHighAgeLimit ||  this.insureAgeI >= this.insHighAgeLimit)
    if (this.reportSourceMap) {
      // 是否已有投保其他商業保險之有效保險契約
      this.written.insOtherYn = this.reportSourceMap.INS_OTHER_YN
      // 要保人已確實瞭解其所繳交保險費係用於
      this.written.insAcceptYn = this.reportSourceMap.INS_ACCEPT_YN
      // 歲(含)以上客戶是否具有辨識不利其投保權益情形之能力
      if (!this.oldAgeDisable) {
        this.written.oldAgeYn = this.reportSourceMap.OLD_AGE_YN
      }
      this.written.retireYear = this.reportSourceMap.RETIRE_YEAR
      // 方便客服電訪時段
      this.written.elecCallTime = this.reportSourceMap.ELEC_CALL_TIME
      // 僅保費來源為貸款、保單解約金、定存解約或透過本公司保單借款填寫
      this.written.insFinlevYn = this.reportSourceMap.INS_FINLEV_YN
      // 保險商品/險種名稱
      this.written.proNameChk = this.reportSourceMap.PRO_NAME_CHK
      if (this.written.proNameChk == this.selChkOther.codeValue) {
        this.written.proNameOther = this.reportSourceMap.PRO_NAME_OTHER
      }
      // 保險金額
      this.written.faceAmtChk = this.reportSourceMap.FACE_AMT_CHK
      if (this.written.faceAmtChk == this.selChkOther.codeValue) {
        this.written.faceAmtOther = this.reportSourceMap.FACE_AMT_OTHER
      }
      // 保障範圍
      this.written.coverageChk =  this.reportSourceMap.COVERAGE_CHK
      if (this.written.coverageChk == this.selChkOther.codeValue) {
        this.written.coverageOther = this.reportSourceMap.COVERAGE_OTHER
      }
      // 保險費及繳費年期
      this.written.modePremChk = this.reportSourceMap.MODE_PREM_CHK
      if (this.written.modePremChk == this.selChkOther.codeValue) {
        this.written.modePremOther = this.reportSourceMap.MODE_PREM_OTHER
      }
      // 建議投保保險公司理由
      this.written.insReasonCode = this.reportSourceMap.INS_REASON_CODE
      if (this.written.insReasonCode == this.insReasonOther.codeValue) {
        this.written.insReasonOther = this.reportSourceMap.INS_REASON_OTHER
      }
    }
    // SRV_3
    if (this.insPoliciesDataList) {
      // 欲投保之保險種類
      const planCodeData = this.insPoliciesDataList.filter(data => data.ins_item === "plan_code")
      if (planCodeData.length > 0) {
        this.written.insTypeCode = planCodeData[0].ins_type_code
        if (this.written.insTypeCode === null) {
          const planOther = this.insTypeList.filter(code => code.codeDesc === "OTHER");
          this.written.insTypeCode = planOther[0].codeValue
          this.written.insTypeOther = planCodeData[0].proname
        }
      }
      // 欲投保之保險金額
      const faceAmtData = this.insPoliciesDataList.filter(data => data.ins_item === "face_amt")
      if (faceAmtData.length > 0) {
         this.written.faceAmt = faceAmtData[0].ins_item_value
      }
      // 保險費金額-繳別
      const modeData = this.insPoliciesDataList.filter(data => data.ins_item === "modx")
      if (modeData.length > 0) {
        this.written.mode = modeData[0].code_value_map
      }
      // 預估繳交之保險費金額-幣別
      const currencyData = this.insPoliciesDataList.filter(data => data.ins_item === "cuy_prem")
      if (currencyData.length > 0) {
        this.written.curCode = currencyData[0].code_value_map
      }

      // 預估繳交之保險費金額-保費
      const amountData= this.insPoliciesDataList.filter(data => data.ins_item === "dis_general_prmm")
      if (amountData.length > 0) {
        this.written.modePrem = amountData[0].ins_item_value
      }
      // 繳交保險費之來源
      const feeSourceData= this.insPoliciesDataList.filter(data => data.ins_item === "fee_source")
      if (feeSourceData.length > 0) {
        const otherTextArray = []
        let feeSourceOther = false
        feeSourceData.forEach(data => {
          if (data.code_value_map === null || data.code_value_map === '') {
            feeSourceOther = true
          } else {
            this.feeSourceSelect.push(data.code_value_map)
          }
        })
        const other = this.feeSourceList.filter(code => code.codeDesc === "OTHER");
        if (feeSourceOther && !this.feeSourceSelect.includes(other[0].codeValue)) {
          this.feeSourceSelect.push(other[0].codeValue)
        }
        // 繳交保險費之來源(可複選)-其他
        if (this.feeSourceSelect.includes(other[0].codeValue)) {
          const otherTextData = feeSourceData.filter(data => data.code_value_map === null)
          if (otherTextData.length > 0) {
            otherTextData.forEach(other=>{
              otherTextArray.push(other.ins_code_name)
            })
          }
          const feeSourceOtherData= this.insPoliciesDataList.filter(data => data.ins_item === "fee_source_other_desc")
          if (feeSourceOtherData.length > 0) {
            otherTextArray.push(feeSourceOtherData[0].ins_item_value)
          }
          if (otherTextArray.length > 0){
            otherTextArray.forEach((item, index) =>{
              if (index === 0) {
                this.written.feeSourceOther += item
              } else {
                this.written.feeSourceOther += "、" + item
              }
            })
          }
        }
        // 繳交保險費之來源為需電訪項目
        let { parameterValue: sourceCode } = this.insParameters['FEE_SOURCE_CODE']
        const callSourceCodeArray = sourceCode.split(",")
        for(var index = 0; index < this.feeSourceSelect.length; index++) {
          if (callSourceCodeArray.includes(this.feeSourceSelect[index])) {
            this.callSourceIncludesFeeSource = true
            break
          }
        }
        // 本次投保之目的及需求
        const insurePurposeArray = this.insPoliciesDataList.filter(data => data.ins_item === "insure_purpose")
        let purOtherArray = []
        if(insurePurposeArray.length > 0){
          insurePurposeArray.forEach(data => {
            if (data.code_value_map !== null ) {
              this.purSelect.push(data.code_value_map)
            }else { // insure_purpose值為空值，則自動勾在「其他」
              this.purSelect.push('5')
              purOtherArray.push(data.ins_code_name)
              this.written.purOther = purOtherArray.toString()
            }
          })
        }
        // 本次投保之目的及需求(其他)
        const insurePurposeOtherArray = this.insPoliciesDataList.filter(data => data.ins_item === "insure_purpose_other")
        if(insurePurposeArray.length > 0){
          insurePurposeOtherArray.forEach(data => {
            if (!isEmpty(data.item_value_map)) {
              purOtherArray.push(data.item_value_map)
            }
            this.written.purOther = purOtherArray.toString()
          })
        }
      }
    }
    //fix by Issue #86616 , 重新調整先固定 written.insAcceptYn = 'Y'
    this.written.insAcceptYn = 'Y'
  },
  beforeRouteEnter (to, from, next) {
    const { transCode } = to.params.propKey
    const reqCusInfo = store.dispatch('ins/fetchCusInfo', { transCode, cusType: ['O'] }) //遠距增加，跳轉APP
    const writtenData = store.dispatch('ins/fetchWrittenData', { transCode })
    const reqPoliciesInfo = store.dispatch('ins/fetchInsPoliciesInfo', { transCode }) //保單資訊
    Promise.all([writtenData,reqCusInfo,reqPoliciesInfo]).then(r => {
        const [rWrittenData,rCusInfo,rPoliciesInfo] = r
      next(vm =>{
          const data = rWrittenData.data
          vm.cusInfoTypeO = rCusInfo.data.cusList[0]  //遠距增加，跳轉APP
          vm.policiesInfo = rPoliciesInfo.data  // 遠距增加，跳轉APP
          vm.compCode = vm.cusInfoTypeO.compCode
          vm.transCode = transCode
          vm.status = data.status
          vm.reportSourceMap = data.reportSourceMap
          vm.insPoliciesDataList = data.insPoliciesDataList
          vm.insureAgeO = data.insureAgeO
          vm.insureAgeI = data.insureAgeI
          vm.written.cusCode = data.cusCode
          vm.written.compCode = data.compCode
          if (data.compName) {
            vm.written.compName = data.compName.replace("人壽", "")
          }
          vm.written.plResult = data.plResult

          // add by Issue #55276
          vm.written.emailO  = data.emailO
          vm.written.cusIdnO  = data.cusIdnO
          vm.written.cusNameO  = data.cusNameO
          vm.written.insAcceptDtO  = data.insAcceptDtO
          vm.written.polInsureType  = data.polInsureType
          if(data.polInsureType === 'R'){
            vm.isTypeR = true
            const today = vm.$toADDate(new Date() ,false)
            if(today > data.insAcceptDtO){
              vm.disableAll = true
            }
          }
          // 填入畫面
          if(vm.reportSourceMap) {
             if(vm.reportSourceMap['PUR_CODE']) {
               vm.purSelect = vm.reportSourceMap['PUR_CODE'].split(',')
             }
             vm.written.purOther =  vm.reportSourceMap['PUR_OTHER']
             if(vm.reportSourceMap['INS_TYPE_CODE']) {
               vm.written.insTypeCode = vm.reportSourceMap['INS_TYPE_CODE']
             }
             vm.written.insTypeOther =  vm.reportSourceMap['INS_TYPE_OTHER']
             vm.written.compCode = vm.reportSourceMap['COMP_CODE']
             vm.written.faceAmt = vm.reportSourceMap['FACE_AMT']
             vm.written.insOtherYn = vm.reportSourceMap['INS_OTHER_YN']
             vm.written.insAcceptYn = vm.reportSourceMap['INS_ACCEPT_YN']
             vm.written.mode =  vm.reportSourceMap['MODE']
             vm.written.curCode = vm.reportSourceMap['CUR_CODE']
             vm.written.modePrem = vm.reportSourceMap['MODE_PREM']
             vm.written.retireYear = vm.reportSourceMap['RETIRE_YEAR']
             if(vm.reportSourceMap['FEE_SOURCE_CODE']) {
                 vm.feeSourceSelect = vm.reportSourceMap['FEE_SOURCE_CODE'].split(',')
             }
             vm.written.feeSourceOther = vm.reportSourceMap['FEE_SOURCE_OTHER']
             vm.written.insFinlevYn = vm.reportSourceMap['INS_FINLEV_YN']
             vm.written.proNameChk = vm.reportSourceMap['PRO_NAME_CHK']
             vm.written.proNameOther = vm.reportSourceMap['PRO_NAME_OTHER']
             vm.written.faceAmtChk = vm.reportSourceMap['FACE_AMT_CHK']
             vm.written.faceAmtOther = vm.reportSourceMap['FACE_AMT_OTHER']
             vm.written.coverageChk = vm.reportSourceMap['COVERAGE_CHK']
             vm.written.coverageOther = vm.reportSourceMap['COVERAGE_OTHER']
             vm.written.modePremChk = vm.reportSourceMap['MODE_PREM_CHK']
             vm.written.modePremOther = vm.reportSourceMap['MODE_PREM_OTHER']
             vm.written.insReasonCode = vm.reportSourceMap['INS_REASON_CODE']
             vm.written.insReasonOther = vm.reportSourceMap['INS_REASON_OTHER']
             vm.written.elecCallTime = vm.reportSourceMap['ELEC_CALL_TIME']
             //fix by Issue #86616 , 修正 written.insAcceptYn 處理規則
             const acceptYnBool = (vm.written.insTypeCode === "3" || vm.written.curCode !== "NTD")
             vm.acceptYnDisable = !acceptYnBool
             //『欲投保之保險種類-代碼』=3 或 「預估繳交之保險費金額-幣別」<>NTD，此欄則勾選是，否則不勾選
             if (acceptYnBool) {
               vm.written.insAcceptYn = 'Y'
             }else{
               vm.written.insAcceptYn = ''
             }
             vm.checkFreeSource()
             vm.getCompName(vm.written.compCode)
          }
          //fix by Issue #86616 , 重新調整先固定 written.insAcceptYn = 'Y'
          vm.written.insAcceptYn = 'Y'
      })
    })
  },
  created () {
  },
  methods: {
    ...mapActions(['fetchInsPoliciesRecords', 'postWrittenData','fetchJumpApp']),
    preStepHandler () {
      this.$postUserAccessLog({ progClassName: 'written_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    },
    showPDFHandler (item) {
      const vm = this
      //fix by Issue #53784
      vm.pdfUrlPath= `/ins/common/insPolicies/recordsOnlyPdf?transCode=${this.transCode}&annexCodeList=A01&compCode=${this.written.compCode}`
      vm.showPdf = true
      // vm.fetchInsPoliciesRecords({
      //   transCode: this.transCode,
      //   annexCodeList: ['A01'],
      //   compCode: this.written.compCode
      // }).then(r => {
      //   const pdfBase64Blob = r.data[0].docContBase64
      //   if (pdfBase64Blob) {
      //     vm.showPdf = true
      //     vm.$nextTick(() => {
      //       vm.pdfBase64 = pdfBase64Blob
      //     })
      //   } else {
      //     vm.pdfBase64 = null
      //     vm.$alert('無要保書資料')
      //   }
      // })
    },
    checkInsTypeCode(val){
      const acceptYnBool = (val === "3" || (this.written.curCode && this.written.curCode !== "NTD"))
      this.acceptYnDisable = !acceptYnBool
      //fix by Issue #86616 , 重新調整先固定 written.insAcceptYn = 'Y'
      // if (acceptYnBool) {
      //   this.written.insAcceptYn = 'Y'
      // }else{
      //   this.written.insAcceptYn = ''
      // }
    },
    checkCurCode(val){
      const acceptYnBool = (this.written.insTypeCode === "3" || val !== "NTD")
      this.acceptYnDisable = !acceptYnBool
      //fix by Issue #86616 , 重新調整先固定 written.insAcceptYn = 'Y'
      // if (acceptYnBool) {
      //   this.written.insAcceptYn = 'Y'
      // }else{
      //   this.written.insAcceptYn = ''
      // }
    },
    pdfViewrClose() {
      this.showPdf = false
    },
    getCompName(val){
      const companyList = this.compList.filter(code => code.codeValue === val)
      if(companyList.length>0){
         const compName = companyList[0].codeName
         this.written.compName = compName.replace('人壽','')
         this.written.compCode = companyList[0].codeValue
      }else{
         this.written.compName = null
      }
    },
    tempSave () {
      /*
      if(this.disableAll){
        this.$alert('暫存成功');
        return //add by Issue #55276
      }
      */
      this.written.transCode = this.transCode
      this.written.purCode = this.purSelect.join(',')
      this.written.feeSourceCode = this.feeSourceSelect.join(',')
      const writtenData = this.written
      if (this.changedFlag) {
        writtenData.changeYn = 'Y'
      }
      //add by Issue #55276  暫存狀態，則存「T」， 若為下一步完成狀態，則存「S」
      writtenData.status = 'T'
      this.postWrittenData(writtenData).then(r => {
        this.$alert('暫存成功')
        this.$postUserAccessLog({ progClassName: 'written_tempsave', methodName: '暫存', stepCode: this.tabStep })
      })
    },
    nextStepHandler: withDebounce(function () {
      const self = this
      /*
      if(self.isTypeR){//add by Issue #55276
        if (self.disableAll) {// R + 目前日期>『進件完成日』
          //直接導向《保經表單頁籤》
          self.$nextStepHandler('n9')
          return
        }
      }
      */
      if (self.isPreview) {
          self.$postUserAccessLog({ progClassName: 'written_next', methodName: '下一步', stepCode: self.tabStep })
          self.$nextStepHandler()
          return
      }

      self.$doValidate('observer').then(isValid => {
        if (isValid) {
          self.validateCheck()
          /*
          let { parameterValue: payWayCode } = self.insParameters['PAY_WAY_CODE']
          const payWayCodeArray = payWayCode.split(",")
          const payWayData= self.insPoliciesDataList.filter(data => data.ins_item === "first_pay_way")
          let payWayAlert = false
          if (payWayData.length > 0) {
            let payWayArray = payWayData[0].ins_item_value.split(",")
            for(var index = 0; index < payWayArray.length; index++) {
              if (payWayCodeArray.includes(payWayArray[index])) {
                payWayAlert = true
                break
              }
            }
          }

          if (payWayAlert || self.isTypeR) {//fix by Issue #58750
            self.$alert('客戶繳費採信用卡或轉帳授權書若有客戶聯請交付客戶,若採匯費請記得攜回匯款單。相關正本請提交分公司結算打包寄送至保經', yn => {
              self.validateCheck()
            })
          } else {
            self.validateCheck()
          }
          */
        }
      })
    }),
    validateCheck(){
       const self = this
      // 檢核前面頁籤必填項目是否皆已填寫
        let errMsg = ''
        this.tabList.forEach(item => {
          if (item.show && item.validateNum > 0) {
            errMsg += item.name + '/'
          }
        })
        if (errMsg.length > 0) {
          this.$alert('請檢視' + errMsg.slice(0, -1) + '頁籤，是否仍有必要未填入欄位！')
          return
        }
        if(self.isTypeR){
           let msg = []
               msg.push('進入保險公司系統則不可再異動基本資料。若需異動可退回網頁重新複製調整後再進件，行動投保同意書需以新案號列印給客戶簽署，採遠距投保時，請複製案件重新調整後再進入保險公司系統')
               msg.push('若繳款人非要/被保險人且為高齡者(65歲以上)，請先完成保險公司高齡錄音取得錄音編號')
               msg.push('若保戶欲投保之商品同時有躉繳及分期繳，採分期繳者請於保險公司系統商品選擇時留意挑有數字的如APKSPL02')
               //msg.push('若採遠距投保，請務必記得書面分析報告需於客戶視訊同一日完成，逾期會導致退件失效')
               msg.push('【遠距投保】請業務同仁應清楚告知客戶進行時之操作環境、步驟與於視訊期間可能發生之問題（如網路中斷）及將採行之調整措施，並提醒客戶視訊時，應確保網路環境之安全（如勿使用公共 Wi-Fi、公用電腦或在公共場所投保等）。(依外規要求辦理) ')
               if (this.cusInfoTypeO.insureAge > this.insHighAgeLimit) { // 檢查要保人是否為高齡(65歲以上)
                 msg.push('您進件之要保人為高齡，請確認是否已於保險公司完成高齡錄音並記下錄音編號(進入保險公司系統時需填寫)')
               }
               if (new Date().getHours() >= this.insAppTime.limit) { // 檢核操作流程時間是否於18點後
                 msg.push('目前已逾' + this.insAppTime.desc + '，因進件保險公司系統僅能同日12小時內完成(不得跨日)，請務必確認今日晚上可完成保險公司系統流程及客戶簽名，以避免需隔日重來。')
               }
               let list = []
               let num = 1
               msg.forEach(el => {
                 el = '(' + num + ')'  + el
                 num++
                 list.push(el)
               })
               const transCode = this.transCode
               this.$confirm('<div style="text-align:left">' + list.join('<br>') + '</div>', yn => {
                if (yn) {
                    this.$store.dispatch('ins/updatePolState', ({ transCode , polState: 'O' })) // 更新保單狀態
                      this.fetchJumpApp({ transCode, compCode: this.compCode, insAcceptNo: this.policiesInfo.insAcceptNo }).then(r => {
                        this.$postUserAccessLog({ progClassName: 'attachmentUpload_jumpApp', methodName: '轉跳APP(遠距)', stepCode: this.tabStep, transCode: this.transCode })
                        const { url } = r.data
                        window.open(url, '_blank') // 跳轉凱壽APP
                         self.nextStep()
                      })
                  }
                })
        }else{
          self.nextStep()
        }
    },
    nextStep() {
      const self = this
      this.written.transCode = this.transCode
      this.written.purCode = this.purSelect.join(',')
      this.written.feeSourceCode = this.feeSourceSelect.join(',')
      const writtenData = this.written
      if (this.changedFlag) {
        writtenData.changeYn = 'Y'
      }
      //add by Issue #55276  暫存狀態，則存「T」， 若為下一步完成狀態，則存「S」
      writtenData.status = 'S'
      this.postWrittenData(writtenData).then(r => {
        //fix by Issue #55276
        const check = r.data
        if (check.statusCode === 'E') { // 失敗
          this.$alert(check.messages)
        }else{
          if(check.messages){//若有訊息文字才需呈現
            this.$alert(check.messages, yn => {
            self.$setTabDone(self.tabStep, true)
              if(self.isTypeR){
                // self.$nextStepHandler('n9')
                this.$router.replace({ name: 'proposal' })
              }else{
                self.$nextStepHandler()
              }
              self.$postUserAccessLog({ progClassName: 'written_next', methodName: '下一步', stepCode: self.tabStep })
            })
          } else {
            self.$setTabDone(self.tabStep, true)
            if(self.isTypeR){
              self.$nextStepHandler('n9')
            }else{
              self.$nextStepHandler()
            }
            self.$postUserAccessLog({ progClassName: 'written_next', methodName: '下一步', stepCode: self.tabStep })
          }
        }
      })
    },
    resetHandler () {
      this.$confirm('是否清除頁面內所有資料，請確認!').then((yn) => {
        if (yn) {
          this.$reset('observer')
           Object.keys(this.written).forEach(key => {
             if(key!=='plResult') {
               this.written[key] = ''
             }
          })
          this.purSelect = []
          this.feeSourceSelect = []
          this.callSourceIncludesFeeSource = false
          this.acceptYnDisable = true
          this.changedFlag = true // 因為沒有v-checker 所以獨立塞值
          this.$postUserAccessLog({ progClassName: 'written_clear', methodName: '全部清除', stepCode: this.tabStep })
        }
      })
    },
    errorsHandler (errors) {
      const errorsArray = this.$errorMsgHandler(errors)
      return errorsArray
    },
    checkFreeSource(){
      let cnt = 0
      const { written } = this
      let { parameterValue: sourceCode } = this.insParameters['FEE_SOURCE_CODE']
        const callSourceCodeArray = sourceCode.split(",")
        for(var index = 0; index < this.feeSourceSelect.length; index++) {
          if (callSourceCodeArray.includes(this.feeSourceSelect[index])) {
            cnt ++
            break
          }
        }
        if(cnt>0){
          this.callSourceIncludesFeeSource = true
        }else{
          this.callSourceIncludesFeeSource = false
          if(written.plResult ==='否') {
             this.written.elecCallTime = ''
             this.written.insFinlevYn = ''
          }
        }
    }
  }
}
</script>
<style lang="stylus" scoped>
.expand-title {
  border-bottom: 2px solid #ededed;
  padding: 8px 0px 18px;
}

.statement-btn {
  font-size: $font-size-md;
  font-weight: bolder;
  color: #fff;
}

//add by Issue #55276，特別指定特定物件的顏色
div.typeR div.v-input >>> label.v-label{
  color: blue!important;
}

</style>
